import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

function getHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' };
}

const api = {
  // Dashboard
  getDashboard: () => axios.get(`${API}/dashboard/stats`, { headers: getHeaders(), withCredentials: false }),

  // Medicines
  getMedicines: (search = '', category = '') => axios.get(`${API}/medicines`, { params: { search, category }, headers: getHeaders(), withCredentials: false }),
  createMedicine: (data) => axios.post(`${API}/medicines`, data, { headers: getHeaders(), withCredentials: false }),
  updateMedicine: (id, data) => axios.put(`${API}/medicines/${id}`, data, { headers: getHeaders(), withCredentials: false }),
  deleteMedicine: (id) => axios.delete(`${API}/medicines/${id}`, { headers: getHeaders(), withCredentials: false }),
  getCategories: () => axios.get(`${API}/medicines/categories`, { headers: getHeaders(), withCredentials: false }),

  // Customers
  getCustomers: (search = '', type = '') => axios.get(`${API}/customers`, { params: { search, customer_type: type }, headers: getHeaders(), withCredentials: false }),
  createCustomer: (data) => axios.post(`${API}/customers`, data, { headers: getHeaders(), withCredentials: false }),
  updateCustomer: (id, data) => axios.put(`${API}/customers/${id}`, data, { headers: getHeaders(), withCredentials: false }),
  deleteCustomer: (id) => axios.delete(`${API}/customers/${id}`, { headers: getHeaders(), withCredentials: false }),

  // Doctors
  getDoctors: (search = '', area = '') => axios.get(`${API}/doctors`, { params: { search, area }, headers: getHeaders(), withCredentials: false }),
  createDoctor: (data) => axios.post(`${API}/doctors`, data, { headers: getHeaders(), withCredentials: false }),
  updateDoctor: (id, data) => axios.put(`${API}/doctors/${id}`, data, { headers: getHeaders(), withCredentials: false }),
  deleteDoctor: (id) => axios.delete(`${API}/doctors/${id}`, { headers: getHeaders(), withCredentials: false }),

  // Sales
  getSales: (params = {}) => axios.get(`${API}/sales`, { params, headers: getHeaders(), withCredentials: false }),
  createSale: (data) => axios.post(`${API}/sales`, data, { headers: getHeaders(), withCredentials: false }),
  getSale: (id) => axios.get(`${API}/sales/${id}`, { headers: getHeaders(), withCredentials: false }),
  deleteSale: (id) => axios.delete(`${API}/sales/${id}`, { headers: getHeaders(), withCredentials: false }),
  getInvoicePdf: (id) => `${API}/sales/${id}/invoice`,

  // Attendance
  getAttendance: (month = '', userId = '') => axios.get(`${API}/attendance`, { params: { month, user_id: userId }, headers: getHeaders(), withCredentials: false }),
  markAttendance: (data) => axios.post(`${API}/attendance`, data, { headers: getHeaders(), withCredentials: false }),

  // Beat Plans
  getBeatPlans: (date = '') => axios.get(`${API}/beat-plans`, { params: { date }, headers: getHeaders(), withCredentials: false }),
  createBeatPlan: (data) => axios.post(`${API}/beat-plans`, data, { headers: getHeaders(), withCredentials: false }),

  // Visits
  logVisit: (data) => axios.post(`${API}/visits`, data, { headers: getHeaders(), withCredentials: false }),
  getVisits: (date = '') => axios.get(`${API}/visits`, { params: { date }, headers: getHeaders(), withCredentials: false }),

  // Expenses
  getExpenses: (month = '') => axios.get(`${API}/expenses`, { params: { month }, headers: getHeaders(), withCredentials: false }),
  createExpense: (data) => axios.post(`${API}/expenses`, data, { headers: getHeaders(), withCredentials: false }),
  approveExpense: (id) => axios.put(`${API}/expenses/${id}/approve`, {}, { headers: getHeaders(), withCredentials: false }),

  // Khata
  getKhata: (params = {}) => axios.get(`${API}/khata`, { params, headers: getHeaders(), withCredentials: false }),
  createKhataEntry: (data) => axios.post(`${API}/khata`, data, { headers: getHeaders(), withCredentials: false }),
  updateKhataEntry: (id, data) => axios.put(`${API}/khata/${id}`, data, { headers: getHeaders(), withCredentials: false }),
  deleteKhataEntry: (id) => axios.delete(`${API}/khata/${id}`, { headers: getHeaders(), withCredentials: false }),
  getKhataSummary: () => axios.get(`${API}/khata/summary`, { headers: getHeaders(), withCredentials: false }),
  getKhataDashboard: () => axios.get(`${API}/khata/dashboard`, { headers: getHeaders(), withCredentials: false }),
  getKhataAudit: (entryId = '') => axios.get(`${API}/khata/audit`, { params: { entry_id: entryId }, headers: getHeaders(), withCredentials: false }),
  getKhataExport: (params = {}) => axios.get(`${API}/khata/export-data`, { params, headers: getHeaders(), withCredentials: false }),
  getKhataExportPdfUrl: (customerId = '', month = '') => `${API}/khata/export-pdf?customer_id=${customerId}&month=${month}`,
  getDoctorPayouts: () => axios.get(`${API}/doctor-payouts`, { headers: getHeaders(), withCredentials: false }),

  // Doctor Ledger (Merged)
  getDoctorLedgerFull: (docId, dateFrom = '', dateTo = '') => axios.get(`${API}/doctor-ledger/${docId}`, { params: { date_from: dateFrom, date_to: dateTo }, headers: getHeaders(), withCredentials: false }),
  exportDoctorLedger: (docId) => axios.get(`${API}/doctor-ledger/${docId}/export`, { headers: getHeaders(), withCredentials: false }),
  getDoctorLedgerPdfUrl: (docId, month = '') => `${API}/doctor-ledger/${docId}/pdf?month=${month}`,

  // QR Code
  getMrAppQrUrl: () => `${API}/staff/mr-app-qr`,

  // Master Settings
  getBankDetails: () => axios.get(`${API}/master/bank-details`, { headers: getHeaders(), withCredentials: false }),
  createBankDetail: (data) => axios.post(`${API}/master/bank-details`, data, { headers: getHeaders(), withCredentials: false }),
  updateBankDetail: (id, data) => axios.put(`${API}/master/bank-details/${id}`, data, { headers: getHeaders(), withCredentials: false }),
  deleteBankDetail: (id) => axios.delete(`${API}/master/bank-details/${id}`, { headers: getHeaders(), withCredentials: false }),
  getCompanyDetails: () => axios.get(`${API}/master/company`, { headers: getHeaders(), withCredentials: false }),
  updateCompanyDetails: (data) => axios.put(`${API}/master/company`, data, { headers: getHeaders(), withCredentials: false }),

  // Sale Edit (password protected)
  updateSale: (id, data) => axios.put(`${API}/sales/${id}`, data, { headers: getHeaders(), withCredentials: false }),

  // Passbook
  getPassbook: () => axios.get(`${API}/passbook`, { headers: getHeaders(), withCredentials: false }),
  createPassbookEntry: (data) => axios.post(`${API}/passbook`, data, { headers: getHeaders(), withCredentials: false }),

  // Gifts
  getGifts: (delivered) => axios.get(`${API}/gifts`, { params: delivered !== undefined ? { delivered } : {}, headers: getHeaders(), withCredentials: false }),
  createGift: (data) => axios.post(`${API}/gifts`, data, { headers: getHeaders(), withCredentials: false }),
  deliverGift: (id, photoId) => axios.put(`${API}/gifts/${id}/deliver`, { photo_id: photoId || '' }, { headers: getHeaders(), withCredentials: false }),

  // Photos
  uploadPhoto: (photoBase64) => axios.post(`${API}/upload-photo`, { photo: photoBase64 }, { headers: getHeaders(), withCredentials: false }),
  getPhoto: (photoId) => axios.get(`${API}/photos/${photoId}`, { headers: getHeaders(), withCredentials: false }),

  // Admin MR Management
  createMR: (data) => axios.post(`${API}/users/create-mr`, data, { headers: getHeaders(), withCredentials: false }),
  updateUser: (id, data) => axios.put(`${API}/users/${id}`, data, { headers: getHeaders(), withCredentials: false }),
  deleteUser: (id) => axios.delete(`${API}/users/${id}`, { headers: getHeaders(), withCredentials: false }),

  // Admin Beat Plan Assignment
  assignBeatPlan: (data) => axios.post(`${API}/beat-plans/assign`, data, { headers: getHeaders(), withCredentials: false }),

  // Admin Gift Assignment
  assignGift: (data) => axios.post(`${API}/gifts/assign`, data, { headers: getHeaders(), withCredentials: false }),

  // Doctor Panel
  getDoctorEarnings: (id) => axios.get(`${API}/doctor-panel/${id}/earnings`, { headers: getHeaders(), withCredentials: false }),
  getDoctorLedger: (id) => axios.get(`${API}/doctor-panel/${id}/ledger`, { headers: getHeaders(), withCredentials: false }),

  // Party Ledger
  getPartyLedger: (id) => axios.get(`${API}/party-ledger/${id}`, { headers: getHeaders(), withCredentials: false }),

  // Staff Attendance & Salary
  markStaffAttendance: (data) => axios.post(`${API}/staff/attendance`, data, { headers: getHeaders(), withCredentials: false }),
  getStaffAttendance: (month = '', userId = '') => axios.get(`${API}/staff/attendance`, { params: { month, user_id: userId }, headers: getHeaders(), withCredentials: false }),
  addSalary: (data) => axios.post(`${API}/staff/salary`, data, { headers: getHeaders(), withCredentials: false }),
  getSalaries: (month = '', userId = '') => axios.get(`${API}/staff/salary`, { params: { month, user_id: userId }, headers: getHeaders(), withCredentials: false }),
  getSalarySlipPdf: (id) => `${API}/staff/salary-slip/${id}`,

  // Staff Deductions
  addDeduction: (data) => axios.post(`${API}/staff/deductions`, data, { headers: getHeaders(), withCredentials: false }),
  getDeductions: (userId = '', month = '') => axios.get(`${API}/staff/deductions`, { params: { user_id: userId, month }, headers: getHeaders(), withCredentials: false }),

  // P&L Report
  getPnlReport: (month = '') => axios.get(`${API}/reports/pnl`, { params: { month }, headers: getHeaders(), withCredentials: false }),

  // Reports
  salesReport: (month = '') => axios.get(`${API}/reports/sales`, { params: { month }, headers: getHeaders(), withCredentials: false }),
  doctorWiseReport: () => axios.get(`${API}/reports/doctor-wise`, { headers: getHeaders(), withCredentials: false }),
  mrPerformanceReport: (month = '') => axios.get(`${API}/reports/mr-performance`, { params: { month }, headers: getHeaders(), withCredentials: false }),

  // Users
  getUsers: (role = '') => axios.get(`${API}/users`, { params: { role }, headers: getHeaders(), withCredentials: false }),

  // Sale Returns
  createSaleReturn: (data) => axios.post(`${API}/sale-returns`, data, { headers: getHeaders(), withCredentials: false }),
  getSaleReturns: (page = 1) => axios.get(`${API}/sale-returns`, { params: { page }, headers: getHeaders(), withCredentials: false }),

  // Vendors
  getVendors: (search = '') => axios.get(`${API}/vendors`, { params: { search }, headers: getHeaders(), withCredentials: false }),
  createVendor: (data) => axios.post(`${API}/vendors`, data, { headers: getHeaders(), withCredentials: false }),
  updateVendor: (id, data) => axios.put(`${API}/vendors/${id}`, data, { headers: getHeaders(), withCredentials: false }),
  deleteVendor: (id) => axios.delete(`${API}/vendors/${id}`, { headers: getHeaders(), withCredentials: false }),

  // Purchases
  createPurchase: (data) => axios.post(`${API}/purchases`, data, { headers: getHeaders(), withCredentials: false }),
  getPurchases: (page = 1, vendorId = '') => axios.get(`${API}/purchases`, { params: { page, vendor_id: vendorId }, headers: getHeaders(), withCredentials: false }),
  getPurchase: (id) => axios.get(`${API}/purchases/${id}`, { headers: getHeaders(), withCredentials: false }),

  // Commission Settlement
  payDoctorCommission: (docId, data) => axios.post(`${API}/doctor-panel/${docId}/pay-commission`, data, { headers: getHeaders(), withCredentials: false }),
  getDoctorSettlements: (docId) => axios.get(`${API}/doctor-panel/${docId}/settlements`, { headers: getHeaders(), withCredentials: false }),

  // Advanced Khata
  getAdvancedKhata: (customerId = '', dateFrom = '', dateTo = '') => axios.get(`${API}/khata/advanced`, { params: { customer_id: customerId, date_from: dateFrom, date_to: dateTo }, headers: getHeaders(), withCredentials: false }),

  // Beats
  getBeats: () => axios.get(`${API}/beats`, { headers: getHeaders(), withCredentials: false }),
  createBeat: (data) => axios.post(`${API}/beats`, data, { headers: getHeaders(), withCredentials: false }),
  updateBeat: (id, data) => axios.put(`${API}/beats/${id}`, data, { headers: getHeaders(), withCredentials: false }),
  deleteBeat: (id) => axios.delete(`${API}/beats/${id}`, { headers: getHeaders(), withCredentials: false }),
  addDoctorToBeat: (beatId, doctorId) => axios.post(`${API}/beats/${beatId}/doctors`, { doctor_id: doctorId }, { headers: getHeaders(), withCredentials: false }),
  removeDoctorFromBeat: (beatId, doctorId) => axios.delete(`${API}/beats/${beatId}/doctors/${doctorId}`, { headers: getHeaders(), withCredentials: false }),

  // Monthly Beat Plans
  assignMonthlyBeatPlan: (data) => axios.post(`${API}/monthly-beat-plans`, data, { headers: getHeaders(), withCredentials: false }),
  getMonthlyBeatPlans: (month = '', userId = '') => axios.get(`${API}/monthly-beat-plans`, { params: { month, user_id: userId }, headers: getHeaders(), withCredentials: false }),
};

export default api;
